import { TGlobalState } from '@types';

export const incidentReportReducerSelector = (state: TGlobalState) => state.incidentReport;
